import Vue from 'vue';
import Router from 'vue-router';
import beneficiarioLogin from './views/beneficiario/Login.vue';
import beneficiarioHome from './views/beneficiario/Index.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: beneficiarioLogin,
      meta: {
        title: () => 'Login  - Unimed Juiz de Fora',
      },
    },
    {
      path: '/',
      name: 'Home',
      component: beneficiarioHome,
      meta: {
        title: () => 'Home  - Unimed Juiz de Fora',
      },
    },
  ],
});
